import WalletModal from "components/Ui/WalletModal/WalletModal";
import VendorWalletPanel from "./VendorWalletPanel";

/**
 * The admin's view of one restaurant's wallet, opened from the restaurants
 * table (admin#41). The same frame and panel as the driver wallet.
 *
 * @param {object} props
 * @param {boolean} props.show
 * @param {Function} props.close
 * @param {{id: number, name: string}|null} props.vendor The table row — `id` is the users.id.
 * @param {Function} props.showMessage
 */
const VendorWalletModal = ({ show, close, vendor, showMessage }) => (
    <WalletModal show={show} close={close} title={`محفظة ${vendor?.name || "المطعم"}`}>
        {vendor?.id ? (
            <VendorWalletPanel userId={vendor.id} canTopUp showMessage={showMessage} />
        ) : null}
    </WalletModal>
);

export default VendorWalletModal;
